export default __webpack_public_path__ + "static/media/user.51a0a538.png";